import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section className="relative w-full bg-stone-50 pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-69">
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-70">
        <div className="max-w-4xl mx-auto text-center" data-id="element-71">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-72">
            <span className="inline-flex items-center gap-2 py-2 px-5 rounded-full bg-teal-600 text-white text-base md:text-lg font-semibold mb-6" data-id="element-73">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-74">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-75" />
              </svg>
              Plantilla de Finanzas Personales
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 tracking-tight mb-6 leading-tight" data-id="element-76">
              El control de tu dinero es el primer paso para construir una vida
              mejor.
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-77">
              Organizar tus finanzas te permite tomar mejores decisiones y
              avanzar con tranquilidad.
            </p>
            <p className="text-lg md:text-xl text-gray-500 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-78">
              Esta plantilla en Google Sheets te ayuda a ordenar ingresos,
              gastos, ahorros y deudas de forma simple, clara y sin
              complicaciones.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col gap-4 mb-10 text-gray-700 max-w-2xl mx-auto" data-id="element-79">
            {['Entendé en qué se va tu dinero', 'Organizá tus deudas con tranquilidad', 'Empezá a ahorrar con un plan real', 'Todo en un solo lugar'].map((item, index) => <div key={index} className="flex items-center gap-3 text-left" data-id="element-80">
                <CheckCircle2 className="w-6 h-6 text-teal-600 flex-shrink-0" data-id="element-81" />
                <span className="font-medium text-lg" data-id="element-82">{item}</span>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-83">
            <Button href="#precio" className="group" data-id="element-84">
              Empezar a ordenar mis finanzas
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-85" />
            </Button>
            <p className="mt-4 text-sm text-gray-500" data-id="element-86">
              Acceso inmediato • Pago único
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}